import React from "react";
import RightArrow from "../../../../Assets/Icons/RightArrow.png";
import LeftArrow from "../../../../Assets/Icons/LeftArrow.png";
import ExtraIcon from "../../../../Assets/Icons/ExtraIcon.png";
import { useTranslation } from "react-i18next";

const manageRequestData = [
  {
    code: "SCPR02",
    serviceGroup: "Medical & Nursing Care",
    subServiceGroup: "Nursing care",
    serviceItem: "Endo-Tracheal Suction",
    createdBy: "Dung",
  },
  {
    code: "SCPR02",
    serviceGroup: "Medical & Nursing Care",
    subServiceGroup: "Nursing care",
    serviceItem: "Endo-Tracheal Suction",
    createdBy: "Gia",
  },
  {
    code: "SCPR02",
    serviceGroup: "Medical & Nursing Care",
    subServiceGroup: "Nursing care",
    serviceItem: "Endo-Tracheal Suction",
    createdBy: "Duy",
  },
  {
    code: "SCPR02",
    serviceGroup: "Medical & Nursing Care",
    subServiceGroup: "Nursing care",
    serviceItem: "Endo-Tracheal Suction",
    createdBy: "Hanh",
  },
  {
    code: "SCPR02",
    serviceGroup: "Medical & Nursing Care",
    subServiceGroup: "Nursing care",
    serviceItem: "Endo-Tracheal Suction",
    createdBy: "Am",
  },
  {
    code: "SCPR02",
    serviceGroup: "Medical & Nursing Care",
    subServiceGroup: "Nursing care",
    serviceItem: "Endo-Tracheal Suction",
    createdBy: "Cam",
  },
];

const MRList = () => {
  const { t } = useTranslation();

  // Mock data for pagination
  const totalPages = 5;
  const currentPage = 1;

  const renderPagination = () => {
    // Mock pagination rendering
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  };

  return (
    <div className="nc-mr-secondary-box">
      <div className="nc-mr-price-box">
        <table className="nc-nr-price-layout">
          <thead className="nc-mr-thead">
            <tr>
              <th>{t("code")}</th>
              <th>{t("serviceGroup")}</th>
              <th>{t("subServiceGroup")}</th>
              <th>{t("serviceItem")}</th>
              <th>{t("createdUpdatedBy")}</th>
            </tr>
          </thead>
          <tbody className="nc-mr-tbody">
            {manageRequestData.map((item, index) => (
              <tr key={index} className="nc-mr-table-row">
                <td>{item.code}</td>
                <td>{item.serviceGroup}</td>
                <td>{item.subServiceGroup}</td>
                <td>{item.serviceItem}</td>
                <td>{item.createdBy}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="nc-mr-pagination-list">
          {totalPages > 0 && (
            <>
              <button disabled={currentPage === 1} className="nc-mr-pagination-prev-list">
                <img src={LeftArrow} alt="<" />
              </button>
              {renderPagination().map((page, index) => (
                <button key={index} className={`nc-mr-pagination-btn-list ${page === currentPage ? "active-list" : ""}`}>
                  {page}
                </button>
              ))}
              <button disabled={currentPage === totalPages} className="nc-mr-pagination-next-list">
                <img src={RightArrow} alt=">" />
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MRList;
